<template>
  <div id="FooterLanding">
    <Wrap>
      <div class="bottom">
        <Row>
          <Column :md="4">
            <div class="logo">
              <Pic alt="Nogrid - efektyvių saulės elektrinių ekspertai" loading="lazy" src="../../../../assets/nogrid-logo.svg" />
            </div>
          </Column>
          <Column :md="4">
            <div class="copyright">
              <div>
                <div>
                  © {{ new Date().getFullYear() }} Nogrid
                </div>
                <div>
                  <Route target="_blank" :title="$t('policy')" to="PrivacyPolicy">
                    {{ $t('policy') }}
                  </Route>
                </div>
              </div>
            </div>
          </Column>
          <Column class="contacts" :md="4">
            <div>
              <div class="line">
                <strong>{{ $t('phoneLabel') }}:</strong>
                <Phone number="+370 602 81 979" />
              </div>
              <div class="line">
                <strong>{{ $t('emailLabel') }}:</strong>
                <Email address="info@nogrid.lt" />
              </div>
              <div class="line">
                <strong>{{ $t('addressLabel') }}:</strong>
                <span class="address">Kauno g. 16, LT-03212, Vilnius</span>
              </div>
            </div>
          </Column>
        </Row>
      </div>
    </Wrap>
  </div>
</template>

<script>
import { getters } from '../utils'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...getters(),
  },
}
</script>

<style lang="scss">
#FooterLanding {
  background: $black;
  color: $white;
  font-weight: $semibold;
  padding-top: 8rem;

  .Wrap {
    padding: 0 2.5rem;
  }

  .bottom {
    color: $white;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 4rem;

    > .Row {
      width: 100%;

      .logo {
        text-align: center;
        @include md {
          text-align: left;
        }

        img {
          height: 3.5rem;
        }
      }

      > div {
        padding: 0.5rem;
        text-align: center;

        &:first-child {
          @include lg {
            text-align: left;
          }
        }
      }
    }

    .copyright {
      color: $white;
      flex-grow: 2;
      font-weight: $regular;
      padding-top: 3rem;
      text-align: center;

      .Route {
        color: $white;
      }

      > div {
        margin-bottom: 0.5rem;
      }

      > a {
        color: $white;
      }
    }

    .contacts {
      display: flex;
      justify-content: flex-end;

      .line {
        text-align: left;

        a, .address {
          color: $white;
          margin-left: 1rem;
        }

        > strong {
          color: $main;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "policy": "Privatumo politika",
    "phoneLabel": "T",
    "emailLabel": "E",
    "addressLabel": "A"
  }
}
</i18n>
